module.exports = __webpack_public_path__ + "src/assets/games/21/133.jpg";